import React from 'react'

const CommonItemExpired = () => {
  return (
    <div className='cards-list__block-item-expired'>
      <span className='cards-list__block-item-expired__text'>Expired</span>
    </div>
  )
}

export default CommonItemExpired;
